<template>
  <div class="bg-gray-200">
    <div class="container py-4">
      <div class="relative">
        <div class="flex rounded-sm z-20">
          <div class="relative flex-grow focus-within:z-10 flex items-center">
            <input
              type="text"
              :placeholder="placeholder"
              @keyup="keyup"
              v-model="keyword"
              ref="searchInput"
              class="input px-5 py-3 border-none md:pr-24"
              :class="[collection.length ? 'rounded-t-md' : 'rounded-md']"
            />
            <img
              src="/assets/images/front/structure/algolia.svg"
              alt="Powered by Algolia"
              class="hidden md:inline-block w-16 absolute right-5"
            />
          </div>
        </div>
        <div
          v-if="collection.length"
          class="absolute block w-full rounded-b-md shadow z-10 overflow-hidden"
        >
          <div
            v-for="(item, index) in collection"
            :key="index"
            class="p-4 border-t border-solid border-gray-200"
            :class="[selectedIndex === index ? 'bg-gray-200' : 'bg-gray-100']"
            @mouseover="selectedIndex = index"
            @click="select"
          >
            <div v-html="item._highlightResult.name.value"></div>
            <small v-html="item._snippetResult.description.value"></small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash';
import algoliasearch from 'algoliasearch';
export default {
  name: 'AlgoliaSearch',
  props: {
    index: {
      type: String,
      default: null,
    },
    hitsPerPage: {
      type: Number,
      default: 5,
    },
    placeholder: {
      type: String,
      default: 'Search the site',
    },
    showClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      client: null,
      searchIndex: null,
      keyword: '',
      collection: [],
      selectedIndex: -1,
      lastEnteredKeyword: '',
      selectedItem: null,
    };
  },
  created() {
    let appId = (
      document.head.querySelector('meta[name="algolia-app-id"]') || {}
    ).content;
    let searchKey = (
      document.head.querySelector('meta[name="algolia-key"]') || {}
    ).content;
    let index =
      this.index ||
      (document.head.querySelector('meta[name="algolia-global-index"]') || {})
        .content;
    if (!appId || !searchKey || !index) {
      return;
    }
    const client = algoliasearch(appId, searchKey);
    this.searchIndex = client.initIndex(index);
  },
  mounted() {
    if (!this.searchIndex) {
      return;
    }

    const bodyHandler = event => {
      if (this.$el.contains(event.target) || this.selectedItem) {
        return;
      }
      this.dismiss();
    };

    const searchFocus = opened => {
      if (opened) {
        this.$nextTick(() => this.$refs.searchInput.focus());
      }
    };

    window.EventBus.listen('body-clicked', bodyHandler);
    window.EventBus.listen('search-form-focus', searchFocus);

    this.$nextTick(() => {
      this.$refs.searchInput.focus();
    });

    this.$once('hook:beforeDestroy', () => {
      window.EventBus.unlisten('body-clicked', bodyHandler);
      window.EventBus.unlisten('search-form-focus', searchFocus);
    });
  },
  destroyed() {
    this.searchIndex = null;
    this.keydown = '';
    this.clear();
  },
  methods: {
    fetch: debounce(function() {
      if (!this.keyword) {
        this.collection = [];
        return;
      }

      this.lastEnteredKeyword = this.keyword;

      this.searchIndex
        .search(this.keyword, {
          hitsPerPage: this.hitsPerPage,
          highlightPreTag: '<strong>',
          highlightPostTag: '</strong>',
        })
        .then(({ hits }) => {
          this.collection = hits;
        })
        .catch(error => {
          this.collection = [];
          console.error(error);
        });
    }, 300),
    keyup(event) {
      switch (event.code) {
        case 'ArrowUp':
          this.arrowUp();
          break;
        case 'ArrowDown':
          this.arrowDown();
          break;
        case 'Escape':
          this.dismiss();
          break;
        case 'Enter':
          this.select(event);
          break;
        default:
          this.fetch();
          break;
      }
    },
    arrowDown() {
      if (this.selectedIndex === this.collection.length - 1) {
        return;
      }

      this.selectedIndex++;
      this.updateKeyword();
    },
    arrowUp() {
      if ([-1, 0].includes(this.selectedIndex)) {
        this.selectedIndex = -1;
        this.resetKeyword();
        return;
      }

      this.selectedIndex--;
      this.updateKeyword();
    },
    readyToSelect() {
      if (this.selectedIndex === -1) {
        this.collection = [];
        return false;
      }
      if (!this.selectedItem) {
        this.selectedItem = this.collection[this.selectedIndex];
        this.updateKeyword();
      }
      return true;
    },
    dismiss() {
      this.keyword = '';
      this.lastEnteredKeyword = '';
      this.clear();
    },
    clear() {
      this.selectedIndex = -1;
      this.collection = [];
    },
    resetKeyword() {
      this.keyword = this.lastEnteredKeyword;
    },
    select(event) {
      if (!this.readyToSelect()) {
        return;
      }

      event.preventDefault();

      this.redirect();
    },
    redirect() {
      window.location.href = this.selectedItem.url;
    },
    updateKeyword() {
      this.keyword = this.collection[this.selectedIndex].name;
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
